// extracted by mini-css-extract-plugin
module.exports = {"vertical-box-align":"_Radio_vertical-box-align_33xtJ","box-size":"_Radio_box-size_undSP","box":"_Radio_box_3DPt5","circle":"_Radio_circle_2dBZa","checked":"_Radio_checked_1SSc-"};